var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlaybackPlay = function SvgPlaybackPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 16.5074V7.49265C6 6.17541 6 5.51679 6.27721 5.12662C6.51917 4.78608 6.89218 4.56186 7.30643 4.50795C7.78105 4.44619 8.36269 4.75518 9.52597 5.37318L18.0104 9.88053C19.3051 10.5683 19.9525 10.9122 20.1643 11.3706C20.3489 11.7699 20.3489 12.2301 20.1643 12.6294C19.9525 13.0878 19.3051 13.4317 18.0104 14.1195L9.52597 18.6268C8.3627 19.2448 7.78105 19.5538 7.30643 19.4921C6.89218 19.4381 6.51917 19.2139 6.27721 18.8734C6 18.4832 6 17.8246 6 16.5074Z",
    fill: "var(--on-surface)",
    fillOpacity: 0.95
  })));
};
export default SvgPlaybackPlay;